import { getHomepageCalculatorUrl } from 'utils/getUrl';
import { getToday } from 'utils/shiftedDateTime';
import { parisIntervalToDuration } from 'utils/durationUtils';
import { useEffect, useMemo, useState } from 'react';
import useAuth from 'hooks/useAuth';
import useClientBlockedStatus from 'hooks/useClientBlockedStatus';

export const useRejectedTimer = () => {
  const { logout } = useAuth();
  const [loading, setLoading] = useState(false);
  const { clientBlockedStatus, fetchClientBlockedStatus } =
    useClientBlockedStatus();

  const onSubmit = async () => {
    try {
      setLoading(true);
      await logout();
    } finally {
      setLoading(false);
      if (typeof window !== 'undefined') {
        window?.location.replace(getHomepageCalculatorUrl());
      }
    }
  };

  useEffect(() => {
    const getTimer = async () => {
      await fetchClientBlockedStatus();
    };
    if (clientBlockedStatus === undefined) getTimer();
  }, []);

  const time = useMemo(() => {
    if (!clientBlockedStatus?.blockedUntil) return;

    // Compute remaining blocked time between now and the unblock date in Paris timezone
    const dueTime = parisIntervalToDuration(
      getToday(),
      clientBlockedStatus.blockedUntil,
    );

    // Parse months to days
    const totalDays =
      (dueTime.years ?? 0) * 365 +
      (dueTime.months ?? 0) * 30 +
      (dueTime.days ?? 0);

    return {
      days: totalDays,
      hours: dueTime.hours,
      minutes: dueTime.minutes,
      seconds: dueTime.seconds,
    };
  }, [clientBlockedStatus]);

  const showTimer = time?.days !== undefined && time.days < 30; // Less than 30 days

  return { loading, showTimer, time, onSubmit };
};
